import { useRouter } from 'next/navigation';

const ALLOWED_ROUTE = [
  '/',
  '/campaign',
  '/dashboard',
  '/applicant',
  '/invite',
  '/ambassador',
  '/sheet-ambassador',
  '/shipping',
  '/newsfeed',
  '/sku',
  '/reward',
  '/product',
  '/sign-up',
  '/sign-in',
  '/user',
  '/faq',
  '/announcement',
] as const;

type AllowedRoute = (typeof ALLOWED_ROUTE)[number];
export type AllowedRoutes =
  | AllowedRoute
  | `${AllowedRoute}/${number | string}`
  | `${AllowedRoute}?${string}`;

type NavigationOptions = Parameters<ReturnType<typeof useRouter>['push']>[1] & {
  shallow?: boolean;
};

const history: string[] = [];
export function useRouterWrapper() {
  const router = useRouter();

  return {
    ...router,
    push: (url: AllowedRoutes, options?: NavigationOptions) => {
      history.push(url);

      if (options?.shallow) {
        return window.history.pushState(null, '', url);
      }

      return router.push(url, options);
    },
    back() {
      history.pop();

      return router.back();
    },
    prefetch: (url: AllowedRoutes, options?: Parameters<typeof router.prefetch>[1]) => {
      return router.prefetch(url, options);
    },
    prefetchAll: () => {
      ALLOWED_ROUTE.forEach((route) => router.prefetch(route));
    },
    replace: (url: AllowedRoutes, options?: NavigationOptions) => {
      history.pop();
      history.push(url);

      if (options?.shallow) {
        return window.history.replaceState(null, '', url);
      }

      return router.replace(url, options);
    },
    getHistory() {
      return history;
    },
  };
}
